"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = void 0;
const react_1 = __importDefault(require("react"));
const config_1 = __importDefault(require("next/config"));
const document_1 = __importStar(require("next/document"));
const styled_components_1 = require("styled-components");
const monera_app_core_1 = require("@amzn/monera-app-core");
const aui_stylesheet_1 = require("@amzn/monera-app-core-components/lib/components/aui-stylesheet");
const shopping_portal_1 = require("@amzn/monera-app-core/lib/utils/shopping-portal");
class Document extends document_1.default {
    static getInitialProps(ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            const { req } = ctx;
            const extendedRequest = req;
            const requestId = extendedRequest.id;
            const isShoppingPortalDisabled = extendedRequest.isShoppingPortalDisabled;
            const cookie = extendedRequest.shoppingPortalRequestHeaders.cookie;
            const deviceAttributes = extendedRequest.shoppingPortalRequestHeaders.deviceAttributes;
            const deviceType = (0, shopping_portal_1.getDeviceType)(deviceAttributes, cookie);
            const stores = (0, monera_app_core_1.getAllStores)(requestId);
            const sheet = new styled_components_1.ServerStyleSheet();
            const page = ctx.renderPage((App) => (props) => sheet.collectStyles(react_1.default.createElement(App, Object.assign({}, props))));
            const styleTags = sheet.getStyleElement();
            return Object.assign(Object.assign({}, page), { styleTags,
                stores,
                requestId,
                isShoppingPortalDisabled,
                deviceType });
        });
    }
    render() {
        const { isShoppingPortalDisabled, requestId, styleTags, styles, stores, deviceType } = this.props;
        (0, monera_app_core_1.deleteAllStores)(requestId);
        const ignoreExpectedErrors = () => {
            const { publicRuntimeConfig } = (0, config_1.default)();
            if (publicRuntimeConfig.envStage === 'local') {
                const messagesToIgnore = ['Uncaught ReferenceError: P is not defined'];
                return (react_1.default.createElement("script", { dangerouslySetInnerHTML: {
                        __html: `
                window.addEventListener('error', function (e) {
                  const { error, message } = e
                  if (!error.handled) {
                    error.handled = true;
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    setTimeout(() => {
                      if (${JSON.stringify(messagesToIgnore)}.includes(message)) {
                        console.warn('Error: "' + error + '" was ignored'); 
                      } else {
                        throw error;
                      }
                    })
                  }
                });
              `
                    } }));
            }
            return;
        };
        const amazonStyleSheets = () => {
            if (isShoppingPortalDisabled) {
                if (deviceType === monera_app_core_1.DeviceType.Mobile || deviceType === monera_app_core_1.DeviceType.MShop) {
                    return aui_stylesheet_1.AuiMobileStyleSheet;
                }
                return aui_stylesheet_1.AuiDesktopStyleSheet;
            }
            return undefined;
        };
        return (react_1.default.createElement(document_1.Html, null,
            react_1.default.createElement(document_1.Head, null,
                ignoreExpectedErrors(),
                amazonStyleSheets(),
                styles,
                styleTags,
                react_1.default.createElement(monera_app_core_1.InitialStateScripts, Object.assign({}, stores))),
            react_1.default.createElement("body", null,
                react_1.default.createElement(document_1.Main, null),
                react_1.default.createElement(document_1.NextScript, null))));
    }
}
exports.Document = Document;
